import { createStore, compose } from "redux";
import reducers from "../reducers";

// for Redux Devtool
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore() {
  return createStore(reducers, composeEnhancers());
}
